import { parseDecimal } from 'features/cashier/services/constants';

export const calcDiscount = (subTotal: number, discountType: string, discountValue: number) => {
  if (discountType === 'PERCENT') {
    return Math.round(subTotal * (discountValue / 100));
  }
  if (discountType === 'MONEY')
    return parseDecimal(discountValue);

  return 0;
};
